export const BasicSwitchData = [
    {
        id: 1,
        mainclass:'d-flex mb-2',
        title: 'Bootstrap Switch',
        checkedclass:false,
        mediaclass: 'text-end'
    },
    {
        id: 2,
        mainclass:'d-flex mb-2',
        title: 'Bootstrap Disable',
        checkedclass:false,
        mediaclass: 'text-end',
        disabled: true
    },
    {
        id: 3,
        mainclass:'d-flex mb-2',
        title: 'Default Switch',
        checkedclass:true,
        mediaclass: 'text-end'
    },
    {
        id: 4,
        mainclass:'d-flex mb-2',
        title: 'Unhecked Switch',
        checkedclass:false,
        mediaclass: 'text-end'
    },
    {
        id: 5,
        mainclass:'d-flex mb-2',
        title: 'With Icon',
        checkedclass: true,
        mediaclass: 'text-end icon-state'
    },
    {
        id: 6,
        mainclass:'d-flex mb-2',
        title: 'Unhecked With Icon',
        checkedclass:false,
        mediaclass: 'text-end icon-state'
    },
    {
        id: 7,
        mainclass:'d-flex mb-2',
        title: 'Disabled State',
        checkedclass:false,
        mediaclass: 'text-end',
        disabled: true
    },
    {
        id: 8,
        mainclass:'d-flex',
        title: 'Disabled With Icon',
        checkedclass:false,
        mediaclass: 'text-end icon-state',
        disabled: true
    }
];

export const Switchcolor = [
    {
        id: 1,
        mainclass:'d-flex mb-2',
        title: 'Bootstrap Switch',
        checkedclass:true,
        mediaclass: 'text-end'
    },
    {
        id: 2,
        mainclass:'d-flex mb-2',
        title: 'Disabled checked',
        checkedclass:true,
        mediaclass: 'text-end',
        disabled: true
    },
    {
        id: 3,
        mainclass:'d-flex mb-2',
        title: 'Primary Color',
        checkedclass:true,
        spanclass: 'switch-state bg-primary',
        mediaclass: 'text-end icon-state'
    },
    {
        id: 4,
        mainclass:'d-flex mb-2',
        title: 'Secondary Color',
        checkedclass:true,
        spanclass: 'switch-state bg-secondary',
        mediaclass: 'text-end icon-state'
    },
    {
        id: 5,
        mainclass:'d-flex mb-2',
        title: 'Success Color',
        checkedclass:true,
        spanclass: 'switch-state bg-success',
        mediaclass: 'text-end icon-state'
    },
    {
        id: 6,
        mainclass:'d-flex mb-2',
        title: 'Info Color',
        checkedclass:true,
        spanclass: 'switch-state bg-info',
        mediaclass: 'text-end icon-state'
    },
    {
        id: 7,
        mainclass:'d-flex mb-2',
        title: 'Warning Color',
        checkedclass:true,
        spanclass: 'switch-state bg-warning',
        mediaclass: 'text-end icon-state'
    },
    {
        id: 8,
        mainclass:'d-flex',
        title: 'Danger Color',
        checkedclass:true,
        spanclass: 'switch-state bg-danger',
        mediaclass: 'text-end icon-state'
    }
];
export const SwitchOutlinecolor = [   
    {
        id: 1,
        mainclass:'d-flex mb-2',
        title: 'Primary Color',
        checkedclass:false,
        spanclass: 'switch-state bg-primary',
        mediaclass: 'text-end icon-state switch-outline'
    },
    {
        id: 2,
        mainclass:'d-flex mb-2',
        title: 'Secondary Color',
        checkedclass:false,
        spanclass: 'switch-state bg-secondary',
        mediaclass: 'text-end icon-state switch-outline'
    },
    {
        id: 3,
        mainclass:'d-flex mb-2',
        title: 'Success Color',
        checkedclass:false,
        spanclass: 'switch-state bg-success',
        mediaclass: 'text-end icon-state switch-outline'
    },
    {
        id: 4,
        mainclass:'d-flex mb-2',
        title: 'Info Color',
        checkedclass:false,
        spanclass: 'switch-state bg-info',
        mediaclass: 'text-end icon-state switch-outline'
    },
    {
        id: 5,
        mainclass:'d-flex mb-2',
        title: 'Warning Color',
        checkedclass:false,
        spanclass: 'switch-state bg-warning',
        mediaclass: 'text-end icon-state switch-outline'
    },
    {
        id: 6,
        mainclass:'d-flex',
        title: 'Danger Color',
        checkedclass:false,
        spanclass: 'switch-state bg-danger',
        mediaclass: 'text-end icon-state switch-outline'
    }
];

export const Switchwithcolor = [
    {
        id: 1,
        mainclass:'d-flex mb-2',
        title: 'Primary Color (Disabled)',
        spanclass: 'switch-state bg-primary',
        mediaclass: 'text-end icon-state switch-lg',
        disabled: true
    },
    {
        id: 2,
        mainclass:'d-flex mb-2',
        title: 'Secondary Color',
        spanclass: 'switch-state bg-secondary',
        mediaclass: 'text-end icon-state switch-lg'
    },
    {
        id: 3,
        mainclass:'d-flex mb-2',
        title: 'Success Color',
        spanclass: 'switch-state bg-success',
        mediaclass: 'text-end icon-state'
    },
    {
        id: 4,
        mainclass:'d-flex mb-2',
        title: 'Info Color',
        spanclass: 'switch-state bg-info',
        mediaclass: 'text-end icon-state'
    },
    {
        id: 5,
        mainclass:'d-flex mb-2',
        title: 'Warning Color',
        spanclass: 'switch-state bg-warning',
        mediaclass: 'text-end icon-state switch-sm'
    },
    {
        id: 6,
        mainclass:'d-flex',
        title: 'Danger Color',
        spanclass: 'switch-state bg-danger',
        mediaclass: 'text-end icon-state switch-sm'
    }
];

export const SwitchSizingData = [
    {
        id: 1,
        mainclass:'d-flex mb-2',
        title: 'Large Size',
        checkedclass: true,
        spanclass: 'switch-state',
        mediaclass: 'text-end switch-lg',
        mediaclass1: 'text-end switch-lg icon-state'
    },
    {
        id: 2,
        mainclass:'d-flex mb-2',
        checkedclass: false,
        title: 'Large Unhecked',
        spanclass: 'switch-state',
        mediaclass: 'text-end switch-lg',
        mediaclass1: 'text-end switch-lg icon-state'
    },
    {
        id: 3,
        mainclass:'d-flex mb-2',
        checkedclass: true,
        title: 'Normal Size',
        spanclass: 'switch-state',
        mediaclass: 'text-end ',
        mediaclass1: 'text-end icon-state'
    },
    {
        id: 4,
        mainclass:'d-flex mb-2',
        checkedclass: false,
        title: 'Normal Unhecked',
        spanclass: 'switch-state',
        mediaclass: 'text-end ',
        mediaclass1: 'text-end icon-state'
    },
    {
        id: 5,
        mainclass:'d-flex mb-2',
        checkedclass: true,
        title: 'Small Size',
        spanclass: 'switch-state',
        mediaclass: 'text-end switch-sm',
        mediaclass1: 'text-end switch-sm icon-state'
    },
    {
        id: 6,
        mainclass:'d-flex',
        checkedclass: false,
        title: 'Small Size Unhecked',
        spanclass: 'switch-state',
        mediaclass: 'text-end switch-sm',
        mediaclass1: 'text-end switch-sm icon-state'
    }
];